module.exports = __webpack_public_path__ + "media/common/images/badges/active/pali_ti_to-41e4e6f9534062466a60312f68803ab0.svg";